var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPlanPaperWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7_2976)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.6988 1.71826L5.18896 20.2232C5.58913 20.4182 6.02804 20.5207 6.47318 20.523H9.64325C9.90845 20.5223 10.1629 20.6277 10.3498 20.8158L12.0678 22.5328C12.9995 23.4709 14.2666 23.9989 15.5887 23.9999C16.1345 23.9994 16.6766 23.9099 17.1937 23.7351C18.9762 23.1507 20.2728 21.6054 20.5387 19.7485L23.9157 3.70808C24.0769 3.03972 24.0002 2.33613 23.6988 1.71826Z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3208 0.0771582L4.31942 3.44816C1.58535 3.82378 -0.326562 6.3447 0.0490558 9.07877C0.19742 10.1585 0.694699 11.1602 1.46514 11.931L3.18212 13.648C3.36979 13.8356 3.47515 14.0902 3.47496 14.3556V17.5257C3.47726 17.9708 3.57976 18.4098 3.77478 18.8099L22.2816 0.300055C21.6735 0.00117271 20.9805 -0.0775768 20.3208 0.0771582Z",
    fill: "#FFF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7_2976"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlanPaperWhite);
export default __webpack_public_path__ + "static/media/planPaperWhite.13c12aedec01b79e9c6c692d9353f49f.svg";
export { ForwardRef as ReactComponent };